import Vue from 'vue';
import Vuex from 'vuex';
import admin from './modules/admin';
import market from './modules/market';
Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    admin: admin,
    market: market
  }
});